module.exports = __webpack_public_path__ + "img/1232128506.e7dd5557.jpg";